import { Icon } from "./icons";

export function FailIcon() {
	return (
		<span>
			<Icon
				name="X"
				className="stroke-red-500"
			/>
		</span>
	);
}
